import { render } from "./BlocksWrapper.vue?vue&type=template&id=061e63e2&scoped=true"
import script from "./BlocksWrapper.vue?vue&type=script&lang=js"
export * from "./BlocksWrapper.vue?vue&type=script&lang=js"

import "./BlocksWrapper.vue?vue&type=style&index=0&id=061e63e2&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061e63e2"]])

export default __exports__